<template>
  <div class="gift-bag-style">
    <div class="components-container">
      <!-- 店铺积分组件 -->
      <div class="component-item" v-if="hasType('6')">
        <div class="component-header">
          <el-checkbox v-model="shopPointsChecked" @change="handleRemovePoint($event, '6')">
            <span class="component-title">店铺积分</span>
          </el-checkbox>

        </div>
        <div class="component-content">
          <div class="input-row">
            <span class="label">每人店铺积分：</span>
            <el-input v-model="shopPoints" @input="handlerPointsInput($event, '6')" placeholder="输入积分" size="small"
              class="custom-input">
            </el-input>
          </div>
        </div>
      </div>

      <!-- 京豆组件 -->
      <div class="component-item" v-if="hasType('4')">
        <div class="component-header">
          <el-checkbox v-model="jingdouChecked" @change="handleRemovePoint($event, '4')">
            <span class="component-title">京豆</span>
          </el-checkbox>

        </div>
        <div class="component-content">
          <div class="input-row">
            <span class="label">每人京豆数量：</span>
            <el-input v-model="jingdouAmount" @input="handlerPointsInput($event, '4')" placeholder="输入京豆" size="small"
              class="custom-input">
            </el-input>
          </div>
          <div class="jingdou-info">
            <span>当前账户余额<span class="highlight">{{ availableNum || 0 }}</span>京豆，预计冻结<span class="highlight">{{
              freezedNum || 0
                }}</span>京豆</span>
            <span class="recharge-link highlight" @click="goRefill">去充值京豆 ></span>
          </div>
          <jd-tip class="mytip">
            <div>
              注：活动创建成功后，京豆将被冻结，如未发放完需到活动时间结束时才会解冻返还
            </div>
          </jd-tip>
        </div>
      </div>

      <!-- 东券组件 pop店 -->
      <div class="component-item" v-if="hasType('1') && !venderType">
        <div class="component-header">
          <el-checkbox v-model="couponChecked" @change="handleRemovePoint($event, '1')">
            <span class="component-title">东券</span>
          </el-checkbox>
        </div>
        <div class="component-content">
          <div class="input-row">
            <span class="label">券类型：</span>
            <el-radio-group v-model="couponType" @change="couponTypeChange">
              <el-radio :label="1">店铺券</el-radio>
              <el-radio :label="2">商品券(支持1000sku)</el-radio>
            </el-radio-group>
          </div>
          <div class="input-row">
            <span class="label">优惠信息：</span>
            <span>满</span>
            <el-input v-model="couponMinAmount" @input="handerCouponInput($event, '1')" placeholder="输入消费金额"
              size="small" class="small-input">
            </el-input>
            <span>减</span>
            <el-input v-model="couponAmount" @input="handerCouponInput($event, '2')" placeholder="输入优惠金额" size="small"
              class="small-input">
            </el-input>
            <span>元</span>
          </div>
          <div class="input-row">
            <span class="label">券有效期：</span>
            <span>领取后</span>
            <el-input v-model="couponValidDays" @input="handerCouponInput($event, '3')" placeholder="输入天数" size="small"
              class="small-input">
            </el-input>
            <span>天有效</span>
          </div>
          <div v-if="couponType === 2" class="input-row">
            <span class="label">适用商品：</span>
            <jd-button @click="exposureProductsFiter">
              添加商品
            </jd-button>
            <span style="margin-left:10px;">已选择 <span class="text_Count">{{ skuIdLength || '0' }}</span>
              个sku</span>
          </div>
        </div>
      </div>

      <!-- 东券组件 自营店 -->
      <div class="component-item" v-if="hasType('1') && venderType">
        <div class="component-header">
          <el-checkbox v-model="couponChecked" @change="handleRemovePoint($event, '1')">
            <span class="component-title">东券</span>
          </el-checkbox>
        </div>
        <div class="component-content">
          <jd-tip class="mytip">
            <div>
              自营店铺需提前在官方创券，并填写优惠券KEY
            </div>
            <div class="helper" @click="toHelper"> 自营券配置教程 </div>
          </jd-tip>
          <div class="input-row" style="margin-top:20px;">
            <span class="label require">putkey：</span>
            <el-input v-model="batchKey" @input="handerCouponInput($event, '4')" placeholder="请输入putkey"
              class="middle-input">
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <!-- 指定购买商品 -->
    <selectGoodsMonitor v-if="selectGoodsStateFilter" ref="selectGoFilter" :isShow="selectGoodsStateFilter" isInteract
      @close="selectGoodsCloseFilter" :moduleType="true" :skuSearch="true" :xianz="false" :skuIdsString="skuIds"
      :echoByIds="true"></selectGoodsMonitor>
  </div>
</template>

<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import { getJingdouBalance } from './jingdouUtils';
export default {
  name: 'GifBagStyle',
  props: {
    libaoList: {
      type: Array,
      default: () => []
    },
    sendCount: { // 发送人数
      type: String,
      default: 0
    }
  },
  components: {
    selectGoodsMonitor
  },
  data() {
    return {
      typeArray: [],
      // 店铺积分
      shopPointsChecked: false,
      shopPoints: '',

      // 京豆
      jingdouChecked: false,
      jingdouAmount: '',

      // 东券
      couponChecked: false,
      couponType: 1, // 1:店铺券 2:商品券
      couponMinAmount: '',
      couponAmount: '',
      couponValidDays: '',

      selectGoodsStateFilter: false, // 选择商品弹窗
      selectGoodsFilterArr: [], // 选择商品数据
      itemListForFilter: [], // 选择商品数据
      skuIds: '', // 选择商品skuIds
      batchKey: '', // 免费抢券key

      availableNum: 0, // 可用京豆

      skuIdLength: 0, // 商品券skuIds长度
      send_count: 0, // 发送人数
      freezedNum: 0, // 预计冻结京豆数量
    }
  },
  created() {
    this.typeArray = this.libaoList.filter(item => item.giftFalse).map(item => item.prizeType);

    // 获取京豆余额
    getJingdouBalance({ venderType: this.venderType }).then(result => {
      if (result.success) {
        this.availableNum = result.availableNum;
      } else {
        this.$message.error(result.message);
      }
    });
  },
  watch: {
    libaoList: {
      handler(newVal) {
        // 更新组件的勾选状态
        console.log("--- this.libaoListnewVal:---", newVal)
        const shopPointsItem = newVal.find(item => item.prizeType === '6')
        const jingdouItem = newVal.find(item => item.prizeType === '4')
        const couponItem = newVal.find(item => item.prizeType === '1')

        if (shopPointsItem) { // 店铺积分 
          this.shopPointsChecked = shopPointsItem.backAction || false
          if (shopPointsItem.singleAmount) {
            this.shopPoints = shopPointsItem.singleAmount
          }
        }

        if (jingdouItem) { // 京豆
          this.jingdouChecked = jingdouItem.backAction || false
          if (jingdouItem.singleAmount) {
            this.jingdouAmount = jingdouItem.singleAmount
          }
        }

        if (couponItem) { // 东券
          this.couponChecked = couponItem.backAction || false
          // 回显
          this.couponMinAmount = couponItem.quota
          this.couponAmount = couponItem.price
          this.couponValidDays = couponItem.validateDay
          this.couponType = couponItem.bindType || 1
          if (this.couponType == 2) { // 商品券需要获取 skuIds
            this.skuIds = couponItem.skuIds
            if (this.skuIds && this.skuIds.length > 0) {
              this.skuIdLength = this.skuIds.split(',').length
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    sendCount: {
      handler(newVal) {
        this.send_count = newVal
      },
      immediate: true
    }
  },
  computed: {
    venderType() {
      // 是否为自营店铺 true: 自营店铺 false: pop店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
  },
  methods: {
    // 检查类型是否存在（同时支持字符串和数字类型）
    hasType(type) {
      return this.typeArray.includes(type) || this.typeArray.includes(Number(type));
    },
    // 处理输入事件(店铺积分/京豆)
    // type 店铺积分:"6" 京豆:"4"
    handlerPointsInput(value, type) {
      let index = this.libaoList.findIndex(item => item.prizeType === type);
      let item = this.libaoList.find(item => item.prizeType === type);
      // 使用正则表达式限制只能输入大于0的数字
      const filtered = String(value).replace(/[^\d]/g, '').replace(/^0+/, '');
      if (type === '6') {
        this.shopPoints = filtered === '0' ? '' : filtered;
        value = this.shopPoints;
      } else if (type === '4') {
        if (this.send_count == 0 || !this.send_count) {
          this.$message.warning('请先设置发送人数');
          this.jingdouAmount = '';
          return;
        }
        // 计算总需京豆数量 = 单人京豆数 × 发送人数
        const totalNeeded = Number(filtered) * Number(this.send_count);

        // 京豆总数不可超过可用京豆
        if (totalNeeded > Number(this.availableNum)) {
          this.$message.warning('京豆总数不可超过可用京豆数量');
          // 计算单人最大可分配京豆数
          const maxPerPerson = Math.floor(Number(this.availableNum) / Number(this.send_count));
          this.jingdouAmount = maxPerPerson.toString();
          // 更新冻结京豆数量
          this.freezedNum = Number(this.jingdouAmount) * this.send_count;
          // 在return前发送事件通知父组件
          this.$emit("handleClickPoint", item, index);
          this.$emit("closePrize", true, { activityName: '', point: this.shopPoints, singleAmount: this.jingdouAmount, prizeType: type, quantityTotal: undefined });
          return;
        }

        this.jingdouAmount = filtered === '0' ? '' : filtered;
        value = this.jingdouAmount;
        this.freezedNum = Number(this.jingdouAmount) * this.send_count;
      }

      if (value) {
        this.$emit("handleClickPoint", item, index)
        this.$emit("closePrize", true, { activityName: '', point: this.shopPoints, singleAmount: this.jingdouAmount, prizeType: type, quantityTotal: undefined });
      } else { // 为空时取消勾选
        this.$emit("handleRemovePoint", item, index)
      }
    },
    // 处理勾选框变化事件
    handleRemovePoint(val, type) {
      let index = this.libaoList.findIndex(item => item.prizeType === type)
      let item = this.libaoList.find(item => item.prizeType === type)
      if (val && (type === "6" || type === "4")) { // 如果想勾选
        this.$emit("handleClickPoint", item, index) // 勾选
        // 传数据
        this.$emit("closePrize", true, { activityName: '', point: this.shopPoints, singleAmount: this.jingdouAmount, prizeType: type, quantityTotal: undefined });
      } else if (val && type === "1") {
        let params = this.getCouponParams()
        item = { ...item, ...params }
        this.$emit("handleClickPoint", item, index) // 勾选
        // 设置东券数据
        this.setDongData()
      } else { // 如果想取消勾选
        this.$emit("handleRemovePoint", item, index) // 取消勾选
      }
    },
    // 处理输入事件(东券)
    // type 满减券:"1" 有效期:"2" 天数:"3"
    handerCouponInput(value, type) {
      // 使用正则表达式限制只能输入大于0的数字
      let filtered =''
      if(type==4){
        filtered = String(value)
      }else{
        filtered= String(value).replace(/[^\d]/g, '').replace(/^0+/, '');
      }
      if (type === '1') {
        this.couponMinAmount = filtered === '0' ? '' : filtered
      } else if (type === '2') {
        this.couponAmount = filtered === '0' ? '' : filtered
      } else if (type === '3') {
        this.couponValidDays = filtered === '0' ? '' : filtered
      } else if (type === '4') {
        this.batchKey = filtered === '0' ? '' : filtered
      }

      // 如果输入了值则自动勾选，否则取消勾选
      let index = this.libaoList.findIndex(item => item.prizeType === '1')
      let item = this.libaoList.find(item => item.prizeType === '1')
      let params = this.getCouponParams()
      // 输入框都为空且为 pop店
      if (!this.venderType) {
        if (!this.couponMinAmount && !this.couponAmount && !this.couponValidDays) {
          this.setDongData()
          this.$emit("handleRemovePoint", item, index)
          return
        } else {
          item = { ...item, ...params }
          this.$emit("handleClickPoint", item, index) // 勾选
        }
      } else {
        // 输入框为空且为自营店
        if (!this.batchKey) {
          this.setDongData()
          this.$emit("handleRemovePoint", item, index) // 取消勾选
          return
        } else {
          item = { ...item, ...params }
          this.$emit("handleClickPoint", item, index) // 勾选
        }
      }
      // 设置东券数据
      this.setDongData()
    },
    // 获取东券相关参数
    getCouponParams() {
      return {
        price: this.couponAmount,
        quota: this.couponMinAmount,
        singleAmount: 1,
        prizeType: '1',
        validateDay: this.couponValidDays,
        title: `满${this.couponMinAmount}减${this.couponAmount}优惠券`,
        totalAmount: '',
        bindType: this.couponType,
      }
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      if (data) {
        this.selectGoodsFilterArr = data.map(item => ({
          skuId: item.skuId,
          logo: item.logo,
          price: item.jdPrice || item.price,
          title: item.wareTitle || item.title
        }));
        this.itemListForFilter = this.selectGoodsFilterArr;
        this.skuIds = this.selectGoodsFilterArr.map(item => item.skuId).join(',');
        this.skuIdLength = this.skuIds ? this.skuIds.split(',').length : 0;
        if (this.skuIds) { // 自动勾选
          this.handleRemovePoint(true, "1");
          this.setDongData();
        }
      }
      this.selectGoodsStateFilter = false;
    },
    // 优惠券类型切换
    couponTypeChange() {
      this.handleRemovePoint(true, "1") // 勾选
      this.setDongData()
    },
    // 设置东券数据
    setDongData() {
      let params = {
        price: this.couponAmount, quota: this.couponMinAmount, singleAmount: 1, prizeType: '1',
        validateDay: this.couponValidDays,
        title: `满${this.couponMinAmount}减${this.couponAmount}优惠券`, totalAmount: '',
        bindType: this.couponType, batchKey: this.batchKey,
      }
      if (this.couponType === 2) {
        params.skuIds = this.skuIds;
      } else {
        params.skuIds = undefined;
      }
      this.$emit("setDonCoupon", params)
    },
    // 去充值京豆
    goRefill() {
      // 在新窗口打开京豆充值页面
      window.open(this.$router.resolve({
        path: '/tool/prizeCenter/assetManagement',
      }).href, '_blank')

    },
    // 去教程
    toHelper() {
      window.open('https://www.yuque.com/yunduanxincrm/flgan6/mn0f6wect45lxa9v', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-bag-style {
  width: 100%;

  .components-container {
    display: flex;
    flex-wrap: wrap;
    width: 780px;
    justify-content: space-between;
  }

  .component-item {
    width: 380px;
    height: 250px;
    background-color: #F8F8F8;
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;

    .component-header {
      padding: 12px;
      display: flex;
      align-items: center;

      .component-title {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .component-content {
      background-color: #FFFFFF;
      border: 1px solid #D7D7D7;
      border-top: none;
      border-radius: 0 0 4px 4px;
      padding: 16px 12px;
      height: calc(100% - 56px);

      .input-row {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .label {
          white-space: nowrap;
          margin-right: 4px;

          &.require {
            &::before {
              content: "*";
              color: red;
              margin-right: 2px;
            }
          }
        }

        .text_Count {
          color: #3159FF;
          margin: 0;
        }

        .custom-input {
          width: 150px;
        }

        .small-input {
          width: 120px;
          margin: 0 4px;
        }

        .middle-input {
          width: 240px;
          margin: 0 4px;
        }
      }

      .jingdou-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        font-size: 12px;

        .highlight {
          color: #3159FF;
        }

        .recharge-link {
          cursor: pointer;
        }
      }
    }
  }
}

:deep(.mytip .left-tip-icon-box) {
  height: 16px;
}

.helper {
  color: #3159FF;
  cursor: pointer;

}
</style>